import { render, staticRenderFns } from "./viewMaterials.vue?vue&type=template&id=81979d16&"
import script from "./viewMaterials.vue?vue&type=script&lang=js&"
export * from "./viewMaterials.vue?vue&type=script&lang=js&"
import style0 from "./viewMaterials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports